module.exports = __webpack_public_path__ + "static/media/be-best.a47767aa.jpg";